import React from 'react'

type AsHeading = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p'

export interface SectionProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: AsHeading
  label: string
}

const Section = ({ as = 'h3', className, label, children }: SectionProps) => {
  const Heading = as
  return (
    <div className={`mc-mb-6 ${className}`}>
      <Heading className='mc-opacity--hinted mc-text--bold mc-mb-4'>
        {label}
      </Heading>
      {children}
    </div>
  )
}

export default Section
